import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableCell, TableContainer, TableHead, TableRow, TableBody, Box, TextField, Tooltip, InputAdornment, IconButton, OutlinedInput } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { delimiters } from "../../../../constants/delimiters";
import Split from "react-split";
import hexToAscii from "../../../../utils/utilFunctions";
import ChatIcon from '@mui/icons-material/Chat';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

export const FieldIdentifier = ({label, value, setValue}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [textBoxVal, setTextBoxVal] = useState('');

  const handleFieldIdentifierChange = (e) => {
    setValue(e.target.value)
  }

  const handleModalOpen = () => {
    setModalOpen(true)
    setTextBoxVal(value);
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  const handleTextBoxChange = (e) => {
    const value = e.target.value.replace(/\n/g, "\r\n");
    setTextBoxVal(value);
  }

  const handleCRLF = () => {
    const input = textBoxVal + `\r\n`;
    setTextBoxVal(input);
  }

  const handleAddButton = (hex) => {
    const input = textBoxVal + hexToAscii(hex)
    setTextBoxVal(input)
  }

  const handleApply = () => {
    setValue(textBoxVal);
    setModalOpen(false);
  }
  const handleClear = () => {
    setTextBoxVal("");
  }

  const padNumber = (num) => {
    const stringNumber = num.toString();
    return stringNumber.length === 1 ? '0' + num : num;
  }

  const delimDisplay = (val) => {
    let temp = val;
    
    if (val === undefined) return '';
    else if(val.includes("%0D%0A")) temp = temp.replaceAll("%0D%0A", "CRLF");
    else if(val.includes("\r\n")) temp = temp.replaceAll("\r\n", "CRLF");
    else if(val.includes("%0D")) temp = temp.replaceAll("%0D", "CR");
    else if(val.includes("\r")) temp = temp.replaceAll("\r", "CR");
    else if(val.includes("%0A")) temp = temp.replaceAll("%0A", "LF");
    else if(val.includes("\n")) temp = temp.replaceAll("\n", "LF");

    try { temp = decodeURIComponent(temp) }

    catch (e) {
      //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
    }
    return temp;
  }

  return (
    <div style={{display: "flex", flex: "1"}}>
      <TextField
        id="fieldFieldIdentifier"
        size="small"
        variant="outlined"
        label={label}
        value={delimDisplay(value)}
        onChange={handleFieldIdentifierChange}
        sx={{ width: "unset", minWidth: "110px", flex: "1"}}
        InputProps={{
          sx: {paddingRight: "0px", height: "34px"},
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="field identifier"
                onClick={handleModalOpen}
                sx={{paddingBottom: "12px !important", borderRadius: "0px", height: "34px"}}
              >
                <b>...</b>
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {/* <Button
        variant="outlined"
        size="small"
        onClick={handleModalOpen}
        style={styles.popupBtn}
      >
        <b>...</b>
      </Button> */}

      {/* character map popup - when user clicks `abc` */}
      <Dialog onClose={handleModalClose} open={modalOpen}  fullWidth maxWidth={"md"}>
        <DialogTitle className="dialog-header padding-12">
          <div className="title margin-left-4">{t('FRG_MSG_SEL_SET') + " " + t("LBL_FIELD_ID").replace(":", "")}</div>
          <Button 
            size="small" 
            style={{position: "absolute", top: "8px", right: "8px", width: "32px", minWidth: "32px", marginRight: "0"}}
            onClick={() => setModalOpen(false)}
          >
            <CloseOutlinedIcon style={{fontSize: "24px"}}/>
          </Button>
        </DialogTitle>
        <DialogContent style={{maxHeight: "40vh",padding: "0px",  overflow: "hidden", fontSize: "12px", fontWeight: "400" }} dividers>
          <Split
            style={{ height: "calc(100% - 42px)"}}
            className="split width-100 flex"
            direction="horizontal"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
            minSize={[50, 50]}
            sizes={[50, 50]}
          >
            <div style={styles.leftContainer}>
              <TableContainer sx={{ maxHeight: "36vh", boxShadow: 0, overflowY: "scroll" }} className='table-border width-fill'>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      {
                        columns?.map((column) => (
                          <TableCell
                            sx={{ backgroundColor: '#fafafa' }}
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {t(column.label)}
                          </TableCell>
                        ))
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      delimiters?.map((delimiter, index) => {
                        return (
                          <TableRow hover key={'delim-' + index} className='dc-row'>
                            <TableCell className='dc-row'>
                              <Button size='small' variant="outlined" onClick={() => { handleAddButton(delimiter.hex) }}>
                                {t('BTN_ADD')}
                              </Button>
                            </TableCell>
                            <TableCell >
                              {`${padNumber(index)}` + ("\xa0").repeat(4) + `${delimiter.display}`}
                            </TableCell>
                            <TableCell>
                              \u00{delimiter.hex}
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={styles.rightContainer}>
              <TextField
                id="fieldIdTextBox"
                label={t("LBL_FIELD_ID").replace(":", "")}
                multiline
                rows={6}
                value={delimDisplay(textBoxVal)}
                onChange={handleTextBoxChange}
                style={{height: "100%"}}
                inputProps={{style: {maxHeight: "36vh", height: "36vh", fontFamily: `"DejaVu Sans", "Arial Unicode MS", sans-serif`}}}
                InputProps={{style: {maxHeight: "36vh", height: "36vh", fontFamily: `"DejaVu Sans", "Arial Unicode MS", sans-serif`}}}
              />
            </div>
          </Split>

        </DialogContent>
        <DialogActions sx={{ marginRight: "8px" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleCRLF}
          >
            {t("LBL_CRLF")}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleClear}
            style={styles.dialogBtn}
          >
            {t("BTN_CLEAR")}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleApply}
            style={styles.dialogBtn}
          >
            {t("APPLY")}
          </Button>
        </DialogActions>
      </Dialog> 
    </div>
  )
}

const columns = [
  { id: 'select', label: 'COL_SELECT', minWidth: 75 },
  { id: 'description', label: 'DESCRIPTION', minWidth: 100 },
  { id: 'hex', label: 'HEX', minWidth: 75 },
];

const styles = {
  popupBtn: {
    minWidth: "32px",
    marginRight: "8px",
    marginTop: "12px"
  },
  dialogBtn: {
    minWidth: "32px",
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    height: "100%",
    boxSizing: "border-box",
    padding: "16px"
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    height: "unset",
    boxSizing: "border-box",
    padding: "16px"
  },
}